import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "accessLevels";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
